/*global tinymce, jQuery */

;(function (tinymce, $) {
  'use strict';
  let A51Paste = function (editor) {
    editor.on('paste', function (e) {
      if (!editor.selection.isCollapsed()) {
        const clipboardData = (e.clipboardData || window.clipboardData);

        if (clipboardData && clipboardData.getData('text/plain') && !clipboardData.getData('text/html')) {
          e.preventDefault();
          const text = clipboardData.getData('text/plain');
          editor.selection.setContent(text);
        }
      }
    })
  }


  tinymce.PluginManager.add('a51paste', function (editor) {
    new A51Paste(editor);
  })
})(tinymce, jQuery);
